// =============================================================================
// features/dashboard/components/ZoneHeading.tsx — Separador das duas zonas.
//
// Diagnóstico D1: a página tinha UM seletor de período no cabeçalho que
// visualmente governava tudo, mas governava só 5 das 13 métricas. Não havia
// nenhuma distinção visual entre "métrica do período" e "estado atual", então o
// usuário fazia o teste óbvio — trocar para "Hoje" — via metade dos números
// parados e concluía que o sistema estava travado. A conclusão era racional.
//
// A correção é dupla: o backend passou a respeitar o período onde fazia sentido,
// e a página passou a dizer, em texto, qual zona obedece ao filtro e qual é
// retrato do agora.
// =============================================================================

import * as React from 'react';

interface ZoneHeadingProps {
  title: string;
  /** Uma linha explicando o que o filtro faz (ou não faz) nesta zona. */
  hint: string;
  /** Selo à direita — ex.: o rótulo do período, ou "agora". */
  badge?: string;
  /** Selo de snapshot muda a cor para diferenciar da zona temporal. */
  tone?: 'range' | 'snapshot';
}

export function ZoneHeading({
  title,
  hint,
  badge,
  tone = 'range',
}: ZoneHeadingProps): React.JSX.Element {
  const isSnapshot = tone === 'snapshot';

  return (
    <div className="flex flex-wrap items-baseline justify-between gap-2 mt-2">
      <div className="flex items-baseline gap-2 flex-wrap">
        <h2
          className="font-display font-bold text-ink"
          style={{ fontSize: 'var(--text-lg)', letterSpacing: '-0.02em' }}
        >
          {title}
        </h2>
        {badge !== undefined && (
          <span
            className="font-mono uppercase rounded-pill px-2 py-0.5"
            style={{
              fontFamily: 'var(--font-mono, "JetBrains Mono", monospace)',
              fontSize: '0.6rem',
              letterSpacing: '0.1em',
              background: isSnapshot ? 'var(--surface-muted)' : 'rgba(27,58,140,0.10)',
              color: isSnapshot ? 'var(--text-3)' : 'var(--brand-azul)',
            }}
          >
            {badge}
          </span>
        )}
      </div>
      <p className="font-sans text-xs" style={{ color: 'var(--text-4)' }}>
        {hint}
      </p>
    </div>
  );
}
